'use client';

import QS from 'query-string';

import { FloatingArea } from '~/components';
import { AppDownloadTrigger } from '~/components/AppDowloadTrigger';
import { useEnvironmentInfo } from '~/hooks';
import { Button } from '@bgzt/ui';
import { goToFullWebviewOnApp } from '~/services/app-interface';
import { ProductDetail } from '../../_queries';

import globalStyles from '~/styles/utils.module.css';
import styles from './PaymentActionButton.module.scss';

type Props = {
  product: ProductDetail['product'];
  shop: ProductDetail['shop'];
};

export const PaymentActionButton = ({ product, shop }: Props) => {
  const { isWebview } = useEnvironmentInfo();
  const handleClick = () => {
    if (!isWebview) return;
    const params = {
      url: `${process.env.NEXT_PUBLIC_PAY_DOMAIN}/purchases/new/${shop.uid}`,
      query: {
        pid: product.pid,
        qty: 1,
        product_price: product.price,
        order_type: 'shipping',
        reg_page_id: '상품상세',
        isOdp: true,
      },
    };
    const purchaseURL = QS.stringifyUrl(params);
    goToFullWebviewOnApp({ url: purchaseURL }).go();
  };

  return (
    <FloatingArea bottom={0} className={styles.wrapper}>
      <AppDownloadTrigger>
        <Button
          width={'100%'}
          size="xlarge"
          type="button"
          disabled={product.saleStatus !== 'SELLING'}
          className={(globalStyles['cta'], styles.purchaseButton)}
          onClick={handleClick}
          variant="primaryRed"
        >
          {product.discount ? '즉시 할인 받고 구매하기' : '구매하기'}
        </Button>
      </AppDownloadTrigger>
    </FloatingArea>
  );
};
